let intlErrorReported = false;
export const getIntlErrors = () => {
    if (globalThis.INTL_ERRORS)
        return globalThis.INTL_ERRORS;
    const intlErrors = new Map();
    globalThis.INTL_ERRORS = intlErrors;
    return intlErrors;
};
getIntlErrors();
const handleIntlErrorDevelopment = (error) => {
    const intlErrors = getIntlErrors();
    const key = error.descriptor
        ? `${error.descriptor.id}: ${error.code}`
        : `${error.code ?? error.name} ${error}`;
    const errors = getIntlErrors();
    let errorSet = errors.get(key);
    if (!errorSet) {
        errorSet = new Set();
        errors.set(key, errorSet);
    }
    const errorMessage = error?.message?.message ?? error?.message ?? error?.toString() ?? error;
    errorSet.add(errorMessage);
    if (!intlErrorReported) {
        console.info('%c[INTL]: %cThere are localization errors. %cYou can inspect INTL_ERRORS global variable for more information:\n%o', 'color:red;font-weight:1000', 'color:red', 'color:blue', intlErrors);
        intlErrorReported = true;
    }
};
export const handleIntlError = process.env.NODE_ENV === 'development' ? handleIntlErrorDevelopment : () => { };
//# sourceMappingURL=handleIntlError.js.map